export default __webpack_public_path__ + "static/media/trophy.a573fedb.svg";